import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";

export function getEmailStatistics(payload) {
  return { type: actionTypes.GET_EMAILSTATISTICS, payload };
}

export function getEmailStatisticsSuccess(payload) {
  console.log(payload);
  const byId = keyBy(payload.email_logs, (logs) => logs.emailstatisticsUid);
  const data = payload;
  return {
    type: actionTypes.GET_EMAILSTATISTICS_SUCCESS,
    payload: { byId, data },
  };
}
